export default __webpack_public_path__ + "static/media/step1.68ce66ef.webp";